import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

const getData = async () => {
	try {
		if (!fg('csm-barista-customer-context-rearch')) return false;
		const data = await fetchJson(
			'/gateway/api/jsm/csm/api/v1/migration/customer-context/storage-architecture/status',
		);
		return data.isMigratedToNewStorageArch;
	} catch (error) {
		fireErrorAnalytics({
			meta: {
				id: 'csmCustomerContextTenantMigratedStatusResource',
				packageName: 'jiraRouterResourcesServiceDeskCustomerServiceCsmMigratedTenantStatus',
				teamName: 'Boysenberry',
			},
			error: error instanceof Error ? error : undefined,
		});

		throw error;
	}
};

export default getData;
